<template>
	<div class="toggle-button">
		<div
			class="button-bg"
			:class="{ 'light': !inputValue }"
			@click="toggleButton"
		>
			<div
				class="button-point"
				:class="{ 'is-active': inputValue }"
			/>
		</div>
		<div
			v-if="inputValue"
			class="section-description is-medium"
		>
			On
		</div>
		<div
			v-else
			class="section-description is-medium"
		>
			Off
		</div>
	</div>
</template>

<script>
export default {
	name: 'AppButtonToggle',

	props: {
		value: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	computed: {
		inputValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},

	methods: {
		toggleButton() {
			this.inputValue = !this.inputValue;
		},
	},
};
</script>

<style lang="scss" scoped>
.toggle-button {
	display: flex;
	align-items: center;

	.section-description {
		color: $color-accent-200;
	}

	.button-bg {
		background-color: $color-secondary-100;
		width: 40px;
		height: 24px;
		border-radius: 12px;
		display: flex;
		align-items: center;
		margin-right: $gap-1;

		&.light {
			background-color: $color-primary;
		}
	}

	.button-point {
		background-color: $color-white;
		width: 22px;
		height: 22px;
		border-radius: 50%;
		margin-left: 1px;
		transition: 200ms ease-in-out;

		&.is-active {
			margin-left: 17px;
		}
	}
}

</style>
